import {
  ROOM_PAY_LABELS, DEPOSIT_PAY_LABELS, BOOKING_PAY_LABELS, PAY_STATUS_STYLES, formatRupiah,
} from "@/components/booking/bookingMeta";

function Line({ label, value, testid }) {
  return (
    <div className="flex items-center justify-between gap-3">
      <span className="text-muted-foreground">{label}</span>
      <span className="text-foreground font-medium" data-testid={testid}>{value}</span>
    </div>
  );
}

function Badge({ label, status, testid }) {
  return (
    <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full border ${PAY_STATUS_STYLES[status] || ""}`} data-testid={testid}>
      {label}
    </span>
  );
}

// Read-only payment breakdown for a booking (room price vs deposit, separate).
export default function PaymentBreakdown({ b, idPrefix = "pay" }) {
  const hasDeposit = (b.deposit_amount || 0) > 0 || (b.deposit_amount_remaining || 0) > 0 || (b.deposit_amount_paid || 0) > 0;
  return (
    <div className="mt-3 rounded-xl border border-border bg-secondary/20 p-3 text-sm space-y-2" data-testid={`${idPrefix}-breakdown`}>
      <div className="space-y-1">
        {b.promo_code && (b.discount_amount || 0) > 0 && (
          <>
            <Line label="Harga Kamar (sebelum diskon)" value={formatRupiah(b.original_room_price_total)} testid={`${idPrefix}-room-original`} />
            <div className="flex items-center justify-between gap-3">
              <span className="text-emerald-600">Diskon {b.promo_code}</span>
              <span className="text-emerald-600 font-medium" data-testid={`${idPrefix}-discount`}>-{formatRupiah(b.discount_amount)}</span>
            </div>
          </>
        )}
        <Line label="Harga Kamar" value={formatRupiah(b.room_price_total)} testid={`${idPrefix}-room-total`} />
        <Line label="Sudah Dibayar" value={formatRupiah(b.room_amount_paid)} testid={`${idPrefix}-room-paid`} />
        <Line label="Sisa Harga Kamar" value={formatRupiah(b.room_amount_remaining)} testid={`${idPrefix}-room-remaining`} />
      </div>
      {hasDeposit && (
        <div className="pt-2 mt-1 border-t border-border space-y-1">
          <Line label="Deposit" value={formatRupiah(b.deposit_amount)} testid={`${idPrefix}-deposit-total`} />
          <Line label="Deposit Dibayar" value={formatRupiah(b.deposit_amount_paid)} testid={`${idPrefix}-deposit-paid`} />
          <Line label="Sisa Deposit" value={formatRupiah(b.deposit_amount_remaining)} testid={`${idPrefix}-deposit-remaining`} />
        </div>
      )}
      <div className="pt-2 mt-1 border-t border-border flex flex-wrap items-center gap-2">
        <span className="text-xs text-muted-foreground">Status Harga:</span>
        <Badge label={ROOM_PAY_LABELS[b.room_payment_status] || b.room_payment_status} status={b.room_payment_status} testid={`${idPrefix}-room-status`} />
        {hasDeposit && (
          <>
            <span className="text-xs text-muted-foreground ml-1">Deposit:</span>
            <Badge label={DEPOSIT_PAY_LABELS[b.deposit_payment_status] || b.deposit_payment_status} status={b.deposit_payment_status} testid={`${idPrefix}-deposit-status`} />
          </>
        )}
        <span className="text-xs text-muted-foreground ml-1">Booking:</span>
        <Badge label={BOOKING_PAY_LABELS[b.booking_payment_status] || b.booking_payment_status} status={b.booking_payment_status} testid={`${idPrefix}-booking-status`} />
      </div>
    </div>
  );
}
